import React, { Component } from 'react'

// utility functions

// TODO: add language support

export function parseContent(content, words, className) {
  let html = addSpaces(content)
  if (words) {
    words.forEach(word => {
      html = addClass(html, word, className)
    })
  }
  return html
}

// turns '//' into </br>
// used because website will need lang translation and some strings need
// specific linebreaks
export function addSpaces(string) {
  if (typeof string === 'undefined' || !string) {
    return ''
  }
  let spaces = new RegExp(' // ', 'g'),
      newString = string.replace(spaces, ' </br>')
  return <span dangerouslySetInnerHTML={{__html: newString}}></span>
}

// adds the given className to a target substring
export function addClass(content, targetWord, className) {
  let string
  if (typeof content === 'object') {
    string = content.props.dangerouslySetInnerHTML.__html
  } else {
    string = content
  }
  let newString = string.replace(targetWord, '<span class=' + className + '>' + targetWord + '</span>')
  return <span dangerouslySetInnerHTML={{__html: newString}}></span>
}

export function changeColor(string, targetWord, targetColor) {
  let newString = string.replace(targetWord, '<span style=color:' + targetColor + ';>' + targetWord + '</span>')
  return <span dangerouslySetInnerHTML={{__html: newString}}></span>
}



// WEBPACK FOOTER //
// ./src/modules/parse.js